import { Menu, VerticalDotsIcon } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';
import NoteStore from '../../../../NoteStore';
import { NotTranslated, T, TranslationsContext } from '../../../../Translations';
import Context from '../../../Context';
import TimeStamp from '../../../TimeStamp';
import * as style from '../../style.module.css';

interface Props {
  noteStore: NoteStore;
  hideContext: boolean;
}

interface State {
  menuOpen: boolean;
  anchorElement: HTMLElement | null;
}

@observer
class NoteDetail extends React.Component<Props, State> {
  state: State = {
    menuOpen: false,
    anchorElement: null,
  };

  handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    this.setState({
      anchorElement: event.currentTarget,
      menuOpen: true,
    });
  };

  handleMenuClose = () => {
    this.setState({ menuOpen: false });
  };

  handleEdit = () => {
    this.handleMenuClose();
    this.props.noteStore.editing();
  };

  handleDelete = () => {
    this.handleMenuClose();
    this.props.noteStore.confirming();
  };

  render() {
    return (
      <TranslationsContext.Consumer>
        {(ts) => (
          <div className={style.note} data-test-note={true}>
            <div className={style.content}>
              <div
                className="m-0 mr-[30px] mt-[3px] font-light italic text-gray-600"
                data-test-note-timestamp={this.props.noteStore.createdAt}
              >
                <TimeStamp timestamp={this.props.noteStore.createdAt} />
              </div>
              {!this.props.hideContext && (
                <div
                  className="m-0 mr-[30px] mt-[3px] font-semibold text-gray-600"
                  data-test-note-context={this.props.noteStore.context}
                >
                  <Context noteStore={this.props.noteStore} />
                </div>
              )}
              <p
                className={style.body}
                data-test-note-body={this.props.noteStore.content.getOrElseValue('')}
              >
                <NotTranslated text={this.props.noteStore.content.getOrElseValue('')} />
              </p>
            </div>
            <div className={style.menu}>
              <button
                type="button"
                onClick={this.handleMenuOpen}
                className="m-0 border-0 bg-transparent p-0"
                aria-label="Note options"
              >
                <VerticalDotsIcon className="cursor-pointer" />
              </button>
              <Menu
                anchorElement={this.state.anchorElement}
                open={this.state.menuOpen}
                onClose={this.handleMenuClose}
                placement="bottom-end"
              >
                <Menu.Item onClick={this.handleEdit}>
                  <T kind="Edit" />
                </Menu.Item>
                <Menu.Item onClick={this.handleDelete}>
                  <T kind="Delete" />
                </Menu.Item>
              </Menu>
            </div>
          </div>
        )}
      </TranslationsContext.Consumer>
    );
  }
}

export default NoteDetail;
